import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";
//import Home from "../views/Home.vue";
//import About from "../views/About.vue";

Vue.use(VueRouter);
import Layout from "../components/Layout.vue";
import Signin from "../views/Signin.vue";
// import Menu01 from "../views/Menu01/Main.vue";
import Menu01 from "../views/Menu01/Main_V2.vue";
import Menu02 from "../views/Menu02/Main.vue";
import MenuDashboard from "../views/Dashboard/Main.vue";
import Menu03 from "../views/Menu03/SeedProductLog.vue";
import Menu04 from "../views/Menu04/VersionsControl.vue";
import Registration from "../views/Registration.vue";
import Registrations from "../views/Registrations.vue";
import RegistrationVietnamese from "../views/RegistrationVietnamese.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ChangePassword from "../views/ChangePassword.vue";
import Report from "../views/Report/report.vue";
import Deeplink from "../views/DeepLink.vue";
import Store from "../views/Store/index.vue";
import Announcement from "../views/Announcement/announcement.vue";
import SettingMaintenance from "../views/SettingMaintenance/maintenance.vue";
import CertificateBackground from "../views/CertificateBackground/CertificateIndex.vue";
import subStore from "../views/Store/_substore/index.vue";

import Library from "../views/DefaultContent/Library/LibraryIndex.vue";
//import subLibrary from "../views/DefaultContent/Library/sub-library/index.vue"
import Banner from "../views/DefaultContent/Banner/banner.vue";
import Course from "../views/DefaultContent/Course/Course.vue";
import KnowledgeSharing from "../views/DefaultContent/KnowledgeSharing/Index.vue";
import SubLibrary from "../views/DefaultContent/Library/sub-library/";
// () => import('../views/Home/Library/sub-library/_subLibrary')
import SubLibraryParts from "../views/DefaultContent/Library/sub-library/sub-library-parts/";

const routes = [
  {
    path: "/",
    name: "Signin",
    component: Signin
  },
  {
    path: "/Registration",
    name: "Registration",
    component: Registration
  },
  {
    path: "/vi/Registrations",
    name: "RegistrationVietnamese",
    component: RegistrationVietnamese
  },
  {
    path: "/en/Registrations",
    name: "Registrations",
    component: Registrations
  },
  {
    path: "/Deeplink",
    name: "Deeplink",
    component: Deeplink
  },
  {
    path: "/ResetPassword",
    component: ResetPassword
  },
  {
    path: "/ChangePassword",
    component: ChangePassword
  },
  // {
  //   path: "/Store",
  //   component: subStore
  // },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: Layout,
    children: [
      {
        path: "dashboardMenu",
        component: MenuDashboard,
        name: "dashboardMenu",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "usermanagement",
        component: Menu02,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "companymanagement",
        component: Menu01,
        name: "companymanagement",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "logs",
        component: Menu03,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "versioncontrol",
        component: Menu04,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "report",
        component: Report,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "store",
        component: Store,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/dashboard/store/article",
        component: subStore
      },
      {
        path: "/dashboard/store/sound",
        component: subStore
      },
      {
        path: "/dashboard/store/video",
        component: subStore
      },
      {
        path: "announcement",
        component: Announcement,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settingmaintenance",
        component: SettingMaintenance,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/default-content/library",
        component: Library,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/default-content/library/:name",
        component: SubLibrary
      },
      {
        path: "/default-content/library/:name/:subName",
        component: SubLibraryParts
      },
      {
        path: "/default-content/course",
        component: Course,
        meta: {
          requiresAuth: true
        }
      },
      // {
      //   path: "/default-content/Library/-library",
      //   component: subLibrary,
      //   meta:{
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: "/default-content/Library/sound",
      //   component: subLibrary
      // },
      // {
      //   path: "/default-content/Library/video",
      //   component: subLibrary
      // },
      {
        path: "/default-content/Banner",
        component: Banner
      },
      {
        path: "/default-content/KnowledgeSharing",
        component: KnowledgeSharing
      },
      {
        path: "certificatebackground",
        component: CertificateBackground,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token");
  if (
    to.path.toLowerCase() == "/registration" ||
    to.path.toLowerCase() == "/vi/registrations" ||
    to.path.toLowerCase() == "/en/registrations" ||
    to.path.toLocaleLowerCase() == "/resetpassword" ||
    to.path.toLocaleLowerCase() == "/changepassword" ||
    to.path.toLowerCase().includes("/deeplink") == true
  )
    next();
  else if (!token && to.path != "/") next("/");
  else next();
});
export default router;
